// @ts-nocheck
import app from 'flarum/forum/app';
import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import ItemList from 'flarum/common/utils/ItemList';
import PostHeaderReputation from './components/PostHeaderReputation';
import ReputationProgressBar from './components/ReputationProgressBar';
import { calculatePercentage } from './utils/calculatePercentage';
import ReputationIncreasedNotification from './components/notifications/ReputationIncreasedNotification';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import ReputationDecreasedNotification from './components/notifications/ReputationDecreasedNotification';
import ReputationUsers from './components/pages/ReputationUsers';
// @ts-ignore
import IndexPage from 'flarum/components/IndexPage';
// @ts-ignore
import LinkButton from 'flarum/components/LinkButton';
import Mithril from 'mithril';
import { Notification, REP_NOTIFICATIONS } from './notifications';
import UserPage from 'flarum/forum/components/UserPage';
import ReputationHistoryPage from './components/pages/ReputationHistoryPage';
import FirstLoginReputationModal from './components/modals/FirstLoginReputationModal';
import Page from 'flarum/common/components/Page';
import Tooltip from 'flarum/common/components/Tooltip';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Discussion from "flarum/common/models/Discussion";
import TagWarningMessage from "./components/TagWarningMessage";


app.initializers.add('justoverclock/reputation-score', (): void => {
  app.notificationComponents.reputationIncreased = ReputationIncreasedNotification;
  app.notificationComponents.reputationDecreased = ReputationDecreasedNotification;
  app.notificationComponents.reputationIncreasedForDiscussion = ReputationIncreasedNotification;
  app.notificationComponents.reputationDecreasedForDiscussion = ReputationDecreasedNotification;
  app.notificationComponents.reputationIncreasedForBestAnswer = ReputationIncreasedNotification;
  app.notificationComponents.reputationDecreasedForBestAnswer = ReputationDecreasedNotification;
  app.notificationComponents.reputationIncreasedForFlag = ReputationIncreasedNotification;

  User.prototype.reputation = Model.attribute('reputation');

  app.routes.topReputation = {
    path: '/top-trusted-users',
    component: ReputationUsers,
  };

  app.routes.reputationHistory = {
    path: '/reputation-history',
    component: ReputationUsers,
  };

  app.routes['user.reputation-history'] = {
    path: '/u/:username/reputation-history',
    component: ReputationHistoryPage,
  };

  extend(Page.prototype, 'oncreate', function () {
    if (app.session.user) {
      setTimeout(() => {
        const isFirstLogin = app.session.user?.data.attributes?.reputation_is_first_login;

        if (isFirstLogin) {
          app.modal.show(FirstLoginReputationModal);
        }
      }, 1000);
    }
  });

  extend(CommentPost.prototype, 'footerItems', function (item) {
    const post = this.attrs.post.data?.attributes?.isHidden;
    const user = this.attrs.post.user();
    const assetsFolder = `${app.forum.attribute('baseUrl')}/assets/extensions/justoverclock-reputation-score`;

    const milestones = {
      ...(user?.data?.attributes?.rewards?.milestones?.post || {}),
      ...(user?.data?.attributes?.rewards?.milestones?.discussions || {}),
      ...(user?.data?.attributes?.rewards?.milestones?.seniority || {}),
    };

    if (!post && user && Object.keys(milestones).length > 0) {
      item.add(
        'reputation-rewards',
        <div class="reputation-score-rewards-container">
          {Object.entries(milestones).map(([key, value], idx) => {
            const count = String(key);
            const milestoneText = app.translator.trans('justoverclock-reputation-score.forum.xPostsReached', { count });

            return (
              <Tooltip text={milestoneText}>
                <img src={`${assetsFolder}/${value}`} alt={`Reward ${idx + 1}`} width={20} height={20} />
              </Tooltip>
            );
          })}
        </div>,
        0
      );
    }
  });

  extend(IndexPage.prototype, 'navItems', (navItems) => {
    navItems.add(
      'topReputation',
      <LinkButton href={app.route('topReputation')} icon="fas fa-crown">
        {app.translator.trans('justoverclock-reputation-score.forum.pageTitle')}
      </LinkButton>
    );
  });

  extend(NotificationGrid.prototype, 'notificationTypes', function (items: ItemList<Notification>) {
    REP_NOTIFICATIONS.forEach((notification) => {
      items.add(notification.name, {
        name: notification.name,
        icon: notification.icon,
        label: notification.label,
      });
    });
  });

  extend(UserPage.prototype, 'navItems', function (items: ItemList<Mithril.Children>) {
    // @ts-ignore missing type-hint in Flarum
    const user = this.user;

    if (user) {
      items.add(
        'reputationHistoryUser',
        <LinkButton href={app.route('user.reputation-history', { username: user?.slug() })} name="reputation-history" icon="fas fa-crown">
          {app.translator.trans('justoverclock-reputation-score.forum.reputationHistory')}
        </LinkButton>
      );
    }
  });

  extend(CommentPost.prototype, 'headerItems', function (items: ItemList<any>) {
    const user: false | User = this.attrs.post.user();
    const post = this.attrs.post;

    if (user && !post.isHidden()) {
      const reputation: unknown = user?.data?.attributes?.reputation;

      items.add('reputation-progress', <ReputationProgressBar value={calculatePercentage(reputation)} />);
      items.add(
        'reputationScore',
        <PostHeaderReputation tooltip={app.translator.trans('justoverclock-reputation-score.forum.reputationBar')} rep={reputation} />
      );
    }
  });

  extend(DiscussionPage.prototype, 'mainContent', function(items) {
    if (app.session.user) {
      const userInSession = app.session.user
      const user = this.discussion.user()
      const discussionTag = this.discussion.tags()[0]
      const requiredReputation = discussionTag && discussionTag.data.attributes.minReputationPoints
      const userReputation = app.session.user.data.attributes.reputation

      if (userInSession && discussionTag && userReputation <= requiredReputation && !app.session.user.isAdmin()) {
        items.add(
          'reputationNotAllowed',
          <button className='Post ReplyPlaceholder' style={{ padding: '20px', margin: 0 }}>
            {app.translator.trans('justoverclock-reputation-score.forum.notEnoughReputationMessage')}
          </button>
        )
      }
    }
  })

  extend(DiscussionPage.prototype, 'mainContent', function (items){
    const user = app.session.user
    const tag = this.discussion.tags()[0]

    if (user && tag && !user.isAdmin() && user.data.attributes.reputation < tag.data.attributes.minReputationPoints) {
      items.add(
        'ReputationTagWarning',
        <TagWarningMessage
          reputationPoints={tag.data.attributes.minReputationPoints}
        />
      )
    }
  })
});
